// src/layouts/PublicLayout.jsx
// Layout des pages PUBLIQUES (indexables par Google) : en-tête flottant en pilule + contenu + footer.
import React, { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";
import Footer from "../component/Footer/Footer";
import amenLogo from "../images/Log1.png";
import mgLogo from "../images/MG.png";
import "./publicLayout.css";

const LINKS = [
  { href: "#categories", label: "Catégories" },
  { href: "#marques", label: "Marques" },
  { href: "#pourquoi", label: "Pourquoi nous" },
  { href: "#contact", label: "Contact" },
];

export default function PublicLayout() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="pub">
      <header className={`pub__header ${scrolled ? "is-scrolled" : ""}`}>
        <div className="pub__bar">
          <Link to="/" className="pub__brand" aria-label="Amen Distribution & MG — accueil" onClick={() => setOpen(false)}>
            <img src={amenLogo} alt="Amen Distribution" className="pub__logo" />
            <span className="pub__logoSep" />
            <img src={mgLogo} alt="MG Distribution" className="pub__logo pub__logo--mg" />
          </Link>

          <nav className={`pub__nav ${open ? "is-open" : ""}`} aria-label="Navigation principale">
            {LINKS.map((l) => (
              <a key={l.href} href={l.href} className="pub__link" onClick={() => setOpen(false)}>
                {l.label}
              </a>
            ))}
            <Link to="/login" className="pub__cta" onClick={() => setOpen(false)}>Espace client</Link>
          </nav>

          <button
            type="button"
            className={`pub__toggle ${open ? "is-open" : ""}`}
            aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <span /><span /><span />
          </button>
        </div>
      </header>

      <main className="pub__main">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
